/**
 * 참고 : https://github.kakaocorp.com/kakaopage/karina/blob/deploy/alpha/modules/karina-core/src/main/kotlin/com/kakaopage/karina/model/enums/SectionType.kt
 */
export enum SectionTypeVo {
  Top = 'TOP',
  TopV2 = 'TOP_V2',
  PromotionBanner = 'PROMOTION_BANNER',
  LineBanner = 'LINE_BANNER',
  CardBanner = 'CARD_BANNER',
  Theme = 'THEME',
  ScrollTheme = 'SCROLL_THEME',
  BigBanner = 'BIG_BANNER',
  DayOfWeek = 'DAY_OF_WEEK',
  Episode = 'EPISODE',
  MainRanking = 'MAIN_RANKING',
  Ranking = 'RANKING',
  RankingV2 = 'RANKING_V2',
  RecentViewed = 'RECENT_VIEWED',
  UserBasedRecommend = 'USER_BASED_RECOMMEND',
  SeriesBasedRecommend = 'SERIES_BASED_RECOMMEND',
  Event = 'EVENT',
  RecommendEvent = 'RECOMMEND_EVENT',
  CashfriendsAd = 'CASHFRIENDS_AD',
  UpdateAlarm = 'UPDATE_ALARM',
  New = 'NEW',
  HelixTheme = 'HELIX_THEME',
  RankingTheme = 'RANKING_THEME',
}
